<template>
  <v-card class="elevation-1">

    <div class="chat-scroll-container" ref="chatContainer">
      <v-layout row wrap>
        <v-flex v-for="mensaje in comentarioPrePartido.respuestas" :key="mensaje.id" class="layout xs12"
          style="padding-top:20px; padding-right: 10px; padding-left: 10px; padding-bottom: 10px;">

          <div v-if='mensaje.autorRol === "0"' style="margin-right:5px; align-self: end"
            class="grey--text xs4 flex text-xs-right">
            {{ mensaje.autorNombre }} - {{ mensaje.created }}
            <div>{{ mensaje.autorFirstName }} {{ mensaje.autorLastName }}</div>
          </div>
          <div style="align-self: end; margin-right:10px">
            <img v-if='mensaje.autorRol === "1"' height="38" :src="mensaje.autorLogo">
          </div>

          <v-card
            :class='[mensaje.autorRol === "0" ? "xs8 primary lighten-3 flex text-left-radius" : " xs8 flex white text-right-radius"]'
            class="elevation-2">
            <v-card-text style="padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom:10px;">
              {{ mensaje.texto }}

              <div v-if="mensaje.assets && mensaje.assets.length">
                <v-divider></v-divider>
                <span v-for="asset in mensaje.assets" :key="asset.id" class="mb-0">
                  <v-icon style="margin-top:10px" small class="mr-1">attach_file</v-icon>
                  <a :href="asset.url" target="_blank" style="text-decoration: none;">
                    {{ getAttachmentName(asset.name) }}
                  </a>
                </span>
              </div>
            </v-card-text>
          </v-card>

          <div style=" margin-left:10px; align-self: end;">
            <img v-if='mensaje.autorRol === "0"' height="38" src="@/assets/icons/lpf_icon_bg_color.png">
          </div>
          <div v-if='mensaje.autorRol === "1"' style="margin-left:5px; align-self: end;" class="grey--text xs4 flex">
            {{ mensaje.autorNombre }} - {{ mensaje.created }}
            <div>{{ mensaje.autorFirstName }} {{ mensaje.autorLastName }}</div>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>

export default {
  name: 'ChatComentarios',
  data () {
    return {
      usuarioActualId: 2
    }
  },
  props: {
    club: null,
    comentarioPrePartido: null
  },
  methods: {
    differentAuthor (autor) {
      return autor.rol !== this.usuarioActualId
    },
    getAttachmentName (name) {
      return name
    },
    scrollToBottom () {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth'
          })
        }
      })
    }
  },
  mounted () {
    this.scrollToBottom()
  },
  watch: {
    'comentarioPrePartido.respuestas': {
      handler () {
        this.scrollToBottom()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.chat-scroll-container {
  max-height: 400px;
  min-height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fafafa;
}

.text-formatted {
  white-space: pre-wrap;
  word-break: break-word;
}

.chat-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.chat-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.chat-scroll-container::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 4px;
}

.chat-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}

.text-left-radius {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-right-radius: 10px
}

.text-right-radius {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}

.avatar-left {
  padding-right: 15px;
}

.avatar-right {
  padding-left: 15px;
}
</style>
